export const updateSidebarClass = (cl) => (dispatch) => {
  dispatch({ type: "UPDATE_SIDEBAR_CLASS", data: cl });
};
